


























































import DatasourceServices from '@/services/datasource';
import SelectRole from './select-role.vue';
import SelectUser from './select-user.vue';
import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { confirmDelete } from '@/libs/decorator';
import { pagination } from '@/libs/util';
@Component({
  components: { SelectRole, SelectUser }
})
export default class DsPermission extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() tableId!: number;
  loading: boolean = false;
  pagination = pagination;

  created() {}

  data: any[] = [];
  dsSrv = new DatasourceServices();
  childShow = true;
  visible = false;
  selectedRowKeys: number[] = [];
  objectType = 'role';
  ObjectTitle = '角色';

  showSelectUser = false;
  showSelectRole = false;

  @Watch('visible')
  onVisibleChange() {
    if (!this.syncVisible) return false;
    this.getDataList();
  }

  onSelectChange(selectedRowKeys: []) {
    this.selectedRowKeys = selectedRowKeys;
  }

  onClose(type: string) {
    this.$emit('onClose', type);
  }

  @confirmDelete()
  async onDelete(ids: number[]) {
    let res = await this.dsSrv.deletePermissions(ids);
    this.getDataList();
  }

  async onCellChange(args: string[], record: any, column: string) {
    record[column] = args[0];
    let params = {
      id: record.id,
      [column]: args[0]
    };
    let res = await this.dsSrv.updatePermission(params);
    if (res) this.getDataList();
  }

  /** 选择类型 */
  async tabChanged(key: string) {
    this.objectType = key;
    this.ObjectTitle = key === 'user' ? '用户' : '角色';
    this.getDataList();
  }
  async getDataList() {
    this.loading = true;
    this.data = await this.dsSrv.permissions({ tableId_eq: this.tableId, objectType_eq: this.objectType });
    this.loading = false;
  }

  /**选择用户角色操作 **/
  showSelect() {
    if (this.objectType === 'user') {
      this.showSelectUser = true;
    } else {
      this.showSelectRole = true;
    }
  }

  async userSelected(args: any[]) {
    let perms = [];
    for (let item of args[0]) {
      perms.push({ status: 0, tableId: this.tableId, objectType: 'user', objectCode: item.staffCode, objectName: item.userName, queryPermission: 1, editPermission: 1, createPermission: 1 });
    }
    await this.dsSrv.savePermissions(perms);
    this.getDataList();
  }
  
  async roleSelected(args: any[]) {
    let perms = [];

    for (let item of args[0]) {
      perms.push({ status: 0, tableId: this.tableId, objectType: 'role', objectCode: item.roleCode, objectName: item.roleName, queryPermission: 1, editPermission: 1, createPermission: 1 });
    }
    await this.dsSrv.savePermissions(perms);
    this.getDataList();
  }

  handleBatch(e: any) {
    if (this.selectedRowKeys.length === 0) {
      this.$message.error('请选中至少一条数据');
      return false;
    }
    if (e.key == 'removeAll') {
      this.onDelete(this.selectedRowKeys);
    }
    if (e.key === 'batchQueryPermission0') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, queryPermission: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchQueryPermission1') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, queryPermission: 1 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchEditPermission0') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, editPermission: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchEditPermission1') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, editPermission: 1 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchCreatePermission0') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, createPermission: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchCreatePermission1') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, createPermission: 1 }));
      this.batchUpdate(paramsArr);
    }
  }

  // 批量更新
  async batchUpdate(paramsArr: any[]) {
    this.loading = true;
    let promiseArr = paramsArr.map((param: any) => {
      return new Promise(async resolve => {
        await this.dsSrv.updatePermission(param).then(res => resolve(res));
      });
    });
    await Promise.all(promiseArr);
    this.loading = false;
    this.getDataList();
    this.selectedRowKeys = [];
  }

  columns = [
    { title: this.ObjectTitle, dataIndex: 'objectName', key: 'objectName', width: 120, scopedSlots: { title: 'title1' } },
    { title: '允许访问数据', dataIndex: 'queryPermission', key: 'queryPermission', width: 80, scopedSlots: { customRender: 'queryPermission' } },
    { title: '允许修改数据', dataIndex: 'editPermission', key: 'editPermission', width: 80, scopedSlots: { customRender: 'editPermission' } },
    { title: '允许创建数据', dataIndex: 'createPermission', key: 'createPermission', width: 80, scopedSlots: { customRender: 'createPermission' } },
    { title: '操作', dataIndex: 'operation', key: 'operation', width: 50, scopedSlots: { customRender: 'operation' } }
  ];
}
